import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {FreeSpinsModule} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsModule';
import {FreeSpinsView} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsView';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';

export class FreeSpinsOutroState extends ModuleState<FreeSpinsView, FreeSpinsModule> {
	public onEnterState(): void {
		this.emit(FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED);
	}

	public onLeaveState(): void {
		this.emit(FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED);
	}

	protected freeSpinsOutroFinished(): void {
		this.module.gotoState(FreeSpinsModule.BASIC_STATE);
	}

	protected setupEvents(): void {
		this.on(FreeSpinsView.FREE_SPINS_OUTRO_FINISHED, this.freeSpinsOutroFinished);
		this.on(ReelsEvents.REELS_FADING_OUT_FINISHED, this.onReelsFadingOutFinished);
		this.on(AvalancheReelsEvents.REELS_FADING_OUT_FINISHED, this.onReelsFadingOutFinished);
	}

	protected onReelsFadingOutFinished(): void {
		const freeSpinTotalWin: number = this.module.logic.freeSpinsTotalWin;

		this.view.showWinSummaryScreen(freeSpinTotalWin * 100);

	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/freespins/intro/states/FreeSpinsOutroState.ts